import { onActivated, onBeforeMount } from 'vue';

export const useProtectRoute = (callback: (...args: any) => any) => {
    callback();

    onActivated(callback);
}